// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "f2eda76236921b4d12c8" + ".chunk.js";
};